// All assets are stored locally in /app/frontend/public/brand/ to ensure
// they survive deployment and never break due to expiring CDN URLs.
export const LOGO_URL = "/brand/logo.png";
export const NADA_PHOTO_URL = "/brand/nada-photo.png";
export const IBCCES_STAMP_URL = "/brand/ibcces-stamp.jpg";
export const ADHD_CERT_URL = "/brand/adhd-certificate.png";
export const SUNFLOWER_FIELD_URL = "/brand/sunflower-field.jpg";
